import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

interface ChannelBox {
  signal: WritableSignal<unknown>;
  channel: BroadcastChannel;
}

@Injectable({ providedIn: 'root' })
export class BroadcastChannelService {
  public static readonly broadcastChannelNames = {
    AccountOverridesSavedChannel: 'accountOverridesSavedChannel',
    MyCompletedTasksChannel: 'myCompletedTasksChannel',
  } as const;

  private channelMap: Map<string, ChannelBox> = new Map();

  postMessageToChannel<T>(
    channelName: (typeof BroadcastChannelService.broadcastChannelNames)[keyof typeof BroadcastChannelService.broadcastChannelNames],
    data: T
  ): void {
    const channelBox = this.getChannelBox<T>(channelName);
    channelBox!.channel.postMessage(data);
    channelBox!.signal.set(data);
  }

  getChannelSignal<T>(
    channelName: (typeof BroadcastChannelService.broadcastChannelNames)[keyof typeof BroadcastChannelService.broadcastChannelNames]
  ): Signal<T> {
    const channelBox = this.getChannelBox<T>(channelName);
    return channelBox!.signal.asReadonly() as Signal<T>;
  }

  private getChannelBox<T>(
    channelName: (typeof BroadcastChannelService.broadcastChannelNames)[keyof typeof BroadcastChannelService.broadcastChannelNames]
  ): ChannelBox | null {
    let channelBox = this.channelMap.get(channelName);
    if (!channelBox) {
      channelBox = {
        signal: signal<T | null>(null),
        channel: new BroadcastChannel(channelName),
      };
      channelBox.channel.onmessage = (event) => {
        channelBox!.signal.set(event.data as T);
      };
      this.channelMap.set(channelName, channelBox);
    }
    return channelBox;
  }
}
